import { getName } from 'country-list';
import get from 'lodash/get';
import { parseRatingType, parseIndustryType, parseDemandType } from 'shared/parsers';

export const entitiesToTableParser = (data) => {
  return data.map((item) => [
    [item.artifactId || item.id, item.product, item.artifactId ? item.id : undefined],
    [item.artifactId || item.id, item.name || item.issuerName],
    item.lei,
    item.countryCode ? getName(item.countryCode) : undefined,
    parseIndustryType(item.industryClassification),
    item.ultimateIssuerId && [item.ultimateIssuerId, item.ultimateIssuerName],
    parseRatingType(item.ratingType),
    parseDemandType(item.longTermRating?.demandType),
    [
      item.artifactId || item.id,
      item.product,
      get(item, 'longTermRating.rating'),
      get(item, 'longTermRating.outlook'),
      item.hasLicence,
      item.longTermRatingTrend,
      get(item, 'previousLongTermRating.rating', '-'),
      get(item, 'previousLongTermRating.outlook', '-'),
      get(item, 'longTermRating.ratingDate', '-'),
      [
        {
          country: item.countryCode,
          industries: item.industryClassification
            ? [parseIndustryType(item.industryClassification)]
            : [],
        },
      ],
      item.longTermRating?.demandType,
    ],
    [
      item.shortTermRating && item.shortTermRating.rating,
      item.shortTermRatingTrend,
      get(item, 'previousShortTermRating.rating', '-'),
      get(item, 'shortTermRating.ratingDate', '-'),
      item.shortTermRating?.demandType,
    ],
    item.publicRating,
    item.subscriptionRating,
    item.rsr,
    item.addedDate,
    [
      item.longTermRatingTrend,
      get(item, 'previousLongTermRating.rating', '-'),
      get(item, 'longTermRating.ratingDate', '-'),
    ],
  ]);
};
